<header class="header-main" [class.header-scrolled]="isScrolled()">
  <ng-template #searchActions>
    @if (!isSearchEmpty()) {
      <i class="pi pi-times header-search-action-icon" role="button" tabindex="0"
         (click)="clearSearch()" (keydown.enter)="clearSearch()" (keydown.space)="clearSearch()" [@fadeIn]
         aria-label="Limpar busca" title="Limpar busca"></i>
    }
    <i class="pi pi-microphone header-search-action-icon header-voice-icon" role="button" tabindex="0"
       [class.listening-animation]="isListening()" (click)="startVoiceSearch()"
       (keydown.enter)="startVoiceSearch()" (keydown.space)="startVoiceSearch()" [@fadeIn]
       [attr.aria-label]="isListening() ? 'Parar gravação' : 'Busca por voz'"
       [attr.title]="isListening() ? 'Parar gravação' : 'Busca por voz'"></i>
  </ng-template>

  <div class="header-container">
    <p-menu
      #menu
      [popup]="true"
      [model]="profileOptions()"
      styleClass="header-profile-menu"
      ariaLabel="Menu do perfil"
      appendTo="body"
    />
    
    <!-- Mobile Layout -->
    @if (isMobile()) {
      <div class="header-mobile-layout">
        <div class="header-mobile-side header-mobile-side--left">
          @if (shouldShowSidebarBtn()) {
            <button
              (click)="toggleSidebar()"
              pButton
              pRipple
              type="button"
              class="p-button-text header-icon-btn"
              [icon]="isSidebarOpen() ? 'pi pi-times' : 'pi pi-bars'"
              [attr.aria-expanded]="isSidebarOpen()"
              [attr.aria-label]="isSidebarOpen() ? 'Fechar menu' : 'Abrir menu'">
            </button>
          }
        </div>

        <a [routerLink]="['/home']" class="header-logo-link-mobile">
          <img
            ngSrc="assets/images/logo-peq.png"
            width="243"
            height="38"
            priority
            alt="Logo" />
        </a>

        <div class="header-mobile-side header-mobile-side--right">
          @if (!isLogged()) {
            <button
              type="button"
              pButton
              pRipple
              class="p-button-text header-icon-btn"
              icon="pi pi-user"
              (click)="openModalLogin($event)"
              aria-label="Entrar ou cadastrar">
            </button>
          } @else {
            <button
              type="button"
              pButton
              pRipple
              class="p-button-text header-icon-btn header-mobile-profile-btn"
              (click)="menu.toggle($event)"
              aria-label="Abrir menu do perfil">
              <span class="mobile-user-avatar" aria-hidden="true">
                {{ formatUserName(user().name || '') | slice:0:1 | uppercase }}
              </span>
            </button>
          }

          <button
            type="button"
            pButton
            pRipple
            class="p-button-text header-icon-btn"
            icon="pi pi-search"
            (click)="toggleSearch()"
            aria-label="Buscar">
          </button>
        </div>
      </div>
    }

    <!-- Desktop Layout -->
    @if (!isMobile()) {
      <div class="header-desktop-layout">
        <div class="header-brand">
          @if (shouldShowSidebarBtn()) {
            <button
              (click)="toggleSidebar()"
              pButton
              pRipple
              type="button"
              class="header-icon-btn"
              [icon]="isSidebarOpen() ? 'pi pi-times' : 'pi pi-bars'"
              [attr.aria-expanded]="isSidebarOpen()"
              [attr.aria-label]="isSidebarOpen() ? 'Fechar menu' : 'Abrir menu'">
            </button>
          }
  
          <a [routerLink]="['/home']" class="header-logo-link-desktop">
            <img
              ngSrc="assets/images/logo-peq.png"
              width="332"
              height="52"
              priority
              alt="Logo Seu Ingresso Aqui" />
          </a>
        </div>

        <div class="header-search-wrapper">
          <form class="header-search-form" (submit)="performSearch()" role="search">
            <div class="header-search-input-wrapper">
              <i class="pi pi-search header-search-icon"></i>
              <input
                type="text"
                pInputText
                placeholder="O que você procura hoje?"
                [(ngModel)]="searchTextValue"
                name="q"
                autocomplete="off"
                enterkeyhint="search"
                inputmode="search"
                (focus)="onSearchFocus()"
                (blur)="onSearchBlur()"
                class="header-search-input" />
                
              <div class="header-search-actions">
                <ng-container [ngTemplateOutlet]="searchActions" />
              </div>
            </div>
            <button
              type="submit"
              pButton
              pRipple
              class="header-search-submit-btn"
              [disabled]="isSearchEmpty()"
              icon="pi pi-search"
              aria-label="Buscar"
              title="Buscar">
            </button>
          </form>
        </div>

        <div class="header-actions">
          @if (isChecking()) {
            <!-- Skeleton Loading State -->
            <div class="flex align-items-center gap-3">
              <!-- Helper to match height -->
              <div class="w-2rem h-2rem border-circle surface-200 animation-pulse"></div>
              <div class="w-8rem h-2rem border-round surface-200 animation-pulse hidden sm:block"></div>
            </div>
          } @else if (!isLogged()) {
            <button
              pButton
              pRipple
              type="button"
              class="header-login-btn"
              (click)="openModalLogin($event)">
              <i class="pi pi-user p-mr-2"></i>
              <span>Entrar / Cadastrar</span>
            </button>
          } @else {
            @if (!auth.isCustomer()) {
              <button
                pButton
                pRipple
                type="button"
                class="p-button-text header-tickets-btn header-icon-btn"
                routerLink="/eventos"
                pTooltip="Meus Eventos"
                tooltipPosition="bottom">
                <i class="pi pi-ticket"></i>
              </button>
            }

            <button
              pButton
              pRipple
              type="button"
              class="header-user-btn"
              (click)="menu.toggle($event)">
              <div class="user-avatar-placeholder">
                {{ formatUserName(user().name || '') | slice:0:1 | uppercase }}
              </div>
              <span class="p-mr-1">{{ formatUserName(user().name || '') | titlecase }}</span>
              <i class="pi pi-chevron-down text-sm opacity-70"></i>
            </button>
          }
        </div>
      </div>
    }
  </div>

  <!-- Accent Line -->
  <div class="header-accent-line"></div>

  <!-- Mobile Search Overlay -->
  @if (isMobile() && isSearching()) {
    <div class="mobile-search-overlay" [@slideDown]>
      <div class="p-p-3">
        <form class="mobile-search-form" (submit)="performSearch()" role="search">
          <button
            type="button"
            pButton
            pRipple
            class="p-button-text header-icon-btn"
            icon="pi pi-arrow-left"
            (click)="closeSearch()"
            aria-label="Voltar">
          </button>
          
          <div class="mobile-search-input-wrapper">
            <i class="pi pi-search mobile-search-icon"></i>
            <input
              #mobileSearchInput
              type="text"
              pInputText
              placeholder="O que você procura?"
              [(ngModel)]="searchTextValue"
              name="qm"
              autocomplete="off"
              enterkeyhint="search"
              inputmode="search"
              (keydown.escape)="closeSearch()"
              class="mobile-search-input" />
            <div class="mobile-search-actions">
              <ng-container [ngTemplateOutlet]="searchActions" />
            </div>
          </div>
          
          <button
            type="submit"
            pButton
            pRipple
            class="header-search-submit-btn"
            [disabled]="isSearchEmpty()"
            icon="pi pi-search"
            aria-label="Buscar">
          </button>
        </form>
        @if (searchText().trim().length > 0) {
          <div 
            class="mobile-search-suggestion"
            role="button"
            tabindex="0"
            (click)="performSearch()"
            (keydown.enter)="performSearch()"
            (keydown.space)="performSearch()"
            [@fadeIn]>
            <i class="pi pi-search"></i>
            <span>{{ searchText() }}</span>
          </div>
        }
      </div>
    </div>
  }
</header>
